import { Component , Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


// Dialog for Additon ROI
@Component({
    templateUrl: 'confirmation-dialog.html',
    styleUrls: ['confirmation-dialog.css'],
  })
  export class DialogConfirmationDialog {

    title: string;
    message: string;


    constructor(
      public dialogRef: MatDialogRef<DialogConfirmationDialog>,
      @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
        this.title = data.title;
        this.message = data.message;
      }
  
    ngOnInit() {
      console.log("dialog data", this.title);

    }
  
    onNoClick(): void {
      this.dialogRef.close();
    }

    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(true);
      }
    
    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
  
  }


/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

    constructor(public title: string, public message: string) {
    }
  }